export default "__VITE_ASSET__B9B9J5rQ__"